module.exports = __webpack_public_path__ + "img/dp-lc1-kong.0b4405a0.png";